import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useStatsStyles } from './ProcessSection.styles';
import { fadeUp, stagger, viewportOnce } from '../../../../styles/animations';

const steps = ['Strategy', 'Design', 'Engineering', 'Growth'];

const ProcessSection = () => {
    const { classes } = useStatsStyles();

    return (
        <Box component="section" className={classes.section}>
            <Box className={classes.inner}>
                <Typography variant="overline" className={classes.eyebrow}>Our process</Typography>

                <motion.div
                    className={classes.row}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    variants={stagger(0.12)}
                >
                    {steps.map((step, i) => (
                        <React.Fragment key={step}>
                            <motion.div variants={fadeUp} className={classes.step}>
                                <Typography variant="overline" className={classes.index}>
                                    {String(i + 1).padStart(2, '0')}
                                </Typography>
                                <Typography variant="h3">{step}</Typography>
                            </motion.div>
                            {i < steps.length - 1 && <Box className={classes.connector} />}
                        </React.Fragment>
                    ))}
                </motion.div>
            </Box>
        </Box>
    );
};

export default ProcessSection;
